import mortgageApi from "~/api/mortgage";
import mortgagePartsApi from "~/api/mortgage_parts";
import mortgagePropertyApi from "~/api/mortgage_property";

const fetchMortgage = async ({ commit }, mortgageId) => {
  const response = await mortgageApi.find(mortgageId);

  commit("setMortgage", response.data);
};

const fetchMortgageParts = async ({ commit }, mortgageId) => {
  const response = await mortgagePartsApi.getByMortgageId(mortgageId);

  commit("setMortgageParts", response.data);
};

const deleteMortgagePartByIndex = async ({ commit, state }, index) => {
  if (state.mortgageParts[index]?.id) {
    await mortgagePartsApi.deleteMortgagePart(state.mortgageParts[index].id);
  }

  commit("removeMortgagePartByIndex", index);
};

const createEmptyMortgagePart = ({ commit }, mortgageId) => {
  commit("addMortgagePart", {
    active: false,
    mortgage_id: mortgageId,
    errors: [],
  });
};

const createEmptyMortgage = ({ commit }, customerId) => {
  commit("setMortgage", {
    customer_id: customerId,
    policies: [],
    errors: [],
  });
};

const saveAll = async ({ state, dispatch }) => {
  let error = null;
  try {
    await dispatch("saveMortgage");
  } catch (e) {
    // The code below makes sure the mortgageParts are also tried to save,
    // in order to obtain the validation errors.
    if (e.response.status === 422) {
      error = e;
    } else {
      throw e;
    }
  }

  const parts = state.mortgageParts ?? [];

  // eslint-disable-next-line no-restricted-syntax,guard-for-in
  for (const index in parts) {
    // eslint-disable-next-line no-await-in-loop
    await dispatch("saveMortgagePartByIndex", index);
  }

  if (error != null) {
    throw error;
  }

  // eslint-disable-next-line no-restricted-syntax,guard-for-in
  for (const index in state.mortgageProperties) {
    // eslint-disable-next-line no-await-in-loop
    await dispatch("attachPropertyToMortgage", index);
  }

  return null;
};

const saveMortgage = async ({ commit, state }) => {
  try {
    if (state.mortgage.id) {
      await mortgageApi.updateMortgage(state.mortgage.id, state.mortgage);
    } else {
      const response = await mortgageApi.saveMortgage(state.mortgage);

      state.mortgage.id = response.data.data.id;
    }
  } catch (e) {
    if (e.response.status === 422) {
      commit("addMortgageErrors", e.response.data.error.errors);
    }

    throw e;
  }

  return null;
};

const saveMortgagePartByIndex = async ({ state, commit }, index) => {
  try {
    if (state.mortgageParts[index].id) {
      await mortgagePartsApi
        .updateMortgagePart(state.mortgageParts[index].id, state.mortgageParts[index]);
    } else {
      await mortgagePartsApi.saveMortgagePart(state.mortgage.id, state.mortgageParts[index]);
    }
  } catch (e) {
    if (e.response.status === 422) {
      commit("addMortgagePartErrors", { index, errors: e.response.data.error.errors });
    }

    throw e;
  }

  return null;
};

const attachPropertyToMortgage = async ({ state }, index) => {
  try {
    await mortgagePropertyApi.create({
      property_id: state.mortgageProperties[index].id,
      mortgage_id: state.mortgage.id,
    });
  } catch (e) {
    this.$notification.error({
      message: "Er iets mis gegaan met toevoegen van het onderpand.",
      description: "Ga naar de bewerk pagina van deze hypotheek en probeer het opnieuw.",
    });
  }

  return null;
};

export default {
  fetchMortgage,
  fetchMortgageParts,
  deleteMortgagePartByIndex,
  createEmptyMortgagePart,
  createEmptyMortgage,
  saveAll,
  saveMortgagePartByIndex,
  saveMortgage,
  attachPropertyToMortgage,
};
